import type { ComuniChannel } from '../../../templates/catalog';
import type { EditFlowSelection, EditFlowStepHandler } from './types';
import { createEmailEditFlowHandler } from './emailEditFlowHandler';
import { createSmsEditFlowHandler } from './smsEditFlowHandler';
import { createWhatsappEditFlowHandler } from './whatsappEditFlowHandler';

export type { EditFlowSelection, EditFlowStepHandler, NamedTemplateSelection, WhatsappEditSelection } from './types';
export {
  buildWhatsappCatalogEditSelection,
  createWhatsappEditFlowHandler,
  findWhatsappTemplateEnumValue,
  formatWhatsappTemplateEnumValue,
  resolveWhatsappEditSelection,
  whatsappEditSelectionKey,
} from './whatsappEditFlowHandler';
export { createSmsEditFlowHandler } from './smsEditFlowHandler';
export { createEmailEditFlowHandler } from './emailEditFlowHandler';
export {
  collectStringEnums,
  createNamedTemplateEditFlowHandler,
  findNamedTemplateEnumValue,
} from './namedTemplateEditFlowHandler';

/** Build the channel-specific Edit/Delete Template step autofill handler. */
export const getEditFlowStepHandler = (channel: ComuniChannel, selection?: EditFlowSelection): EditFlowStepHandler => {
  switch (channel) {
    case 'whatsapp':
      return createWhatsappEditFlowHandler(selection?.channel === 'whatsapp' ? selection.template : undefined);
    case 'sms':
      return createSmsEditFlowHandler(selection?.channel === 'sms' ? selection.template : undefined);
    case 'email':
      return createEmailEditFlowHandler(selection?.channel === 'email' ? selection.template : undefined);
  }
};
